export const bonuses = [
  {
    number: 1,
    title: "Early Orthodontic Assessment Checklist™",
    value: 37,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/153372d2-a95a-4c97-8ebe-18ba8b5c97ec.jpg",
    description: "A structured checklist for organizing the main areas of early orthodontic assessment.",
    includesLabel: "Includes:",
    items: [
      "Patient history review.",
      "Dental development observations.",
      "Occlusal relationship assessment.",
      "Functional considerations.",
      "Relevant diagnostic records.",
      "Findings requiring further evaluation.",
    ],
    why: "It provides a consistent framework for reviewing the components of an early orthodontic assessment.",
  },
  {
    number: 2,
    title: "Mixed Dentition Visual Reference Atlas™",
    value: 27,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/7e7acae5-dace-4a9a-9398-bc4857198a93.jpg",
    description:
      "A visual educational atlas covering the developmental changes and dental relationships commonly evaluated during mixed dentition.",
    includesLabel: "Includes:",
    items: [
      "Eruption reference illustrations.",
      "Dentition development charts.",
      "Arch relationship diagrams.",
      "Space assessment concepts.",
      "Developmental comparison sheets.",
    ],
    why: "It makes complex developmental concepts easier to review visually.",
  },
  {
    number: 3,
    title: "Interceptive Treatment Decision Cards™",
    value: 29,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/3bbd0aad-0bde-49ae-a1b6-bd89a511cc93.jpg",
    description:
      "A collection of educational decision cards designed around common clinical assessment scenarios. Each card introduces a finding and prompts you to consider relevant diagnostic and developmental factors.",
    includesLabel: "Includes scenarios involving:",
    items: [
      "Crossbite assessment.",
      "Developing sagittal discrepancies.",
      "Vertical occlusal problems.",
      "Eruption disturbances.",
      "Space-related concerns.",
      "Observation and referral considerations.",
    ],
    why: "It encourages structured reasoning before moving toward a treatment decision.",
  },
  {
    number: 4,
    title: "Phase I Case Planning Workbook™",
    value: 27,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/149f5dee-2d30-4b2c-ab74-f3c7d761f2b0.jpg",
    description: "A reusable workbook for organizing early orthodontic case information.",
    includesLabel: "Includes worksheets for:",
    items: [
      "Clinical findings.",
      "Problem identification.",
      "Growth considerations.",
      "Treatment objectives.",
      "Potential limitations.",
      "Follow-up planning.",
    ],
    why: "It provides a place to organize educational case-planning exercises rather than beginning with a blank page.",
  },
  {
    number: 5,
    title: "Early Orthodontic Monitoring Toolkit™",
    value: 27,
    image:
      "https://cdn.magicpatterns.com/patterns/generated-images/0ece2bd1-cba8-42af-8b5a-dcd6443aad43.jpg",
    description:
      "A collection of templates for learning how to organize follow-up information in growing patients.",
    includesLabel: "Includes:",
    items: [
      "Reassessment worksheets.",
      "Developmental observation logs.",
      "Treatment objective review sheets.",
      "Progress documentation templates.",
      "Clinical case summary pages.",
    ],
    why: "It helps connect initial assessment concepts with ongoing monitoring and reassessment.",
  },
];

export const valueStack = [
  { label: "6 Specialized Clinical Volumes", value: 97 },
  { label: "Bonus #1 — Early Assessment Checklist", value: 37 },
  { label: "Bonus #2 — Mixed Dentition Atlas", value: 27 },
  { label: "Bonus #3 — Treatment Decision Cards", value: 29 },
  { label: "Bonus #4 — Phase I Planning Workbook", value: 27 },
  { label: "Bonus #5 — Monitoring Toolkit", value: 27 },
];

export const offerIncludes = [
  "6 specialized digital volumes.",
  "5 professional educational bonuses.",
  "Practical clinical reference materials.",
  "Reusable worksheets and templates.",
  "Immediate digital access.",
  "Lifetime access to the purchased materials.",
  "No monthly subscription.",
];
